import { Tag } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SQC_STATUS } from '../../../main/main-constant';
import { MNQC_STATUS } from '../../../main/Screen/FoodMenu/redux/foodmenu-constant';
import { PDQC_STATUS } from '../../../main/Screen/MartProduct/redux/martProduct-constant';
import colors from '../../theme/colors';

export const RBHQCTag: React.FC<IProps> = (props) => {
  const { qcStatus, id, marginTop = 0 } = props;

  const getColorAndText = () => {
    switch (qcStatus) {
      case SQC_STATUS.SQC_REJECT:
      case MNQC_STATUS.MNQC_REJECT:
      case PDQC_STATUS.PDQC_REJECT:
        return { text: 'main.qctag.reject', textColor: colors.tagRed, bgColor: 'red', borderColor: colors.tagLightred };
      case SQC_STATUS.SQC_APPROVE:
      case MNQC_STATUS.MNQC_APPROVE:
      case PDQC_STATUS.PDQC_APPROVE:
        return { text: 'main.qctag.approve', textColor: colors.tagGreen, bgColor: 'green', borderColor: colors.tagLightgreen };
      default:
        return { text: 'main.qctag.pending', textColor: colors.tagYellow, bgColor: 'yellow', borderColor: colors.tagLightyellow };
    }
  };

  const statusObject: IObjectStatus = getColorAndText();

  return (
    <Tag style={{ marginTop, color: statusObject.textColor, borderColor: statusObject.borderColor }} color={statusObject.bgColor}
      id={`${id}_${statusObject.bgColor}`} data-testid={`${id}_${statusObject.bgColor}`}>
      <FormattedMessage id={statusObject.text} />
    </Tag>
  );
};

interface IObjectStatus {
  text: string;
  textColor: string;
  bgColor: string;
  borderColor: string;
}

interface IProps {
  qcStatus?: SQC_STATUS | MNQC_STATUS | PDQC_STATUS;
  id?: string;
  marginTop?: number;
}

export default RBHQCTag;
